var forgotpassword = {
    forgot: "FORGOT PASSWORD?",
    eyebrowLabel: "Password support",
    text1: "Enter your email to reset your password",
    text2: "We will send you a secure link so you can create a new password.",
    panelTitle: "Recover access to your account",
    panelText: "Use the email address associated with your account. If it exists in our system, you will receive instructions to reset your password.",
    email: "Email:",
    emailPlaceholder: "name@agency.com",
    sendbtn: "Send",
    sending: "Sending...",
    requiredEmail: "Email is required.",
    invalidEmail: "Enter a valid email address.",
    genericError: "We could not process your request right now. Please try again later.",
    successTitle: "Check your inbox",
    successText: "If the email is registered, we sent you instructions to reset your password.",
    successHelp: "Please also review your spam or junk folder if you do not see the message in the next few minutes.",
    backToLogin: "Back to login",
    resend: "Send another email",
    msg: "An email with instructions to reset your password has been sent to you"
}
module.exports = forgotpassword
